
export const animations = `
@keyframes expanding-circle {
  0% {
    transform: scale(1);
  }
  10% {
    transform: scale(1.1);
  }
  15% {
    transform: scale(1.2);
  }
  20% {
    transform: scale(1.3);
  }
  25% {
    transform: scale(1.4);
  }
  30% {
    transform: scale(1.5);
  }
  35% {
    transform: scale(1.6);
  }
  40% {
    transform: scale(1.7);
  }
  45% {
    transform: scale(1.8);
  }
  50% {
    transform: scale(1.9);
    opacity:0.9;
  }
  55% {
    transform: scale(2);
    opacity:0.8;
  }
  60% {
    transform: scale(2.1);
    opacity:0.7;
  }
  65% {
    transform: scale(2.2);
    opacity:0.6;
  }
  70% {
    transform: scale(2.3);
    opacity:0.5;
  }
  75% {
    transform: scale(2.4);
    opacity:0.4;

  }
  80% {
    transform: scale(2.5);
    opacity:0.3;

  }
  85% {
    transform: scale(2.6);
    opacity:0.2;

  }
  90% {
    transform: scale(2.7);
    opacity:0.1;

  }
  95% {
    transform: scale(2.8);
    opacity:0;

  }
  100% {
    transform: scale(2.9);
    opacity:0;

  }
 
}
@keyframes tooltip-animation {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
    
@keyframes retro-future-tv-lines {
  0% {
    -webkit-mask-position: center 0rem;
    mask-position: center 0rem;
  }
  100% {
    -webkit-mask-position: center -2.5rem;
    mask-position: center -2.5rem;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2021-2-4 12:2:8
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
@keyframes pulsate-bck{0%{transform:scale(1)}50%{transform:scale(.9)}100%{transform:scale(1)}}
@keyframes scale-in-tr{0%{transform:scale(0);transform-origin:100% 0;opacity:1}100%{transform:scale(1);transform-origin:100% 0;opacity:1}}
@keyframes scale-in-tl{0%{transform:scale(0);transform-origin:0 0;opacity:1}100%{transform:scale(1);transform-origin:0 0;opacity:1}}
@keyframes pulsate-fwd{0%{transform:scale(1)}50%{transform:scale(1.2)}100%{transform:scale(1)}}
@keyframes vibrate-1{0%{transform:translate(0)}20%{transform:translate(-1px,1px)}40%{transform:translate(-1px,-1px)}60%{transform:translate(1px,1px)}80%{transform:translate(1px,-1px)}100%{transform:translate(0)}}
/* ------------------------------------------------------- */
@keyframes glitch-animation {
    0% {
      opacity: 1;
      transform: translateZ(0);
      clip-path: polygon(0 2%, 100% 2%, 100% 5%, 0 5%);
    }
  
    2% {
      clip-path: polygon(0 78%, 100% 78%, 100% 100%, 0 100%);
      transform: translate(-5px);
    }
  
    6% {
      clip-path: polygon(0 78%, 100% 78%, 100% 100%, 0 100%);
      transform: translate(5px);
    }
  
    8% {
      clip-path: polygon(0 78%, 100% 78%, 100% 100%, 0 100%);
      transform: translate(-5px);
    }
  
    9% {
      clip-path: polygon(0 78%, 100% 78%, 100% 100%, 0 100%);
      transform: translate(0);
    }
  
    10% {
      clip-path: polygon(0 54%, 100% 54%, 100% 44%, 0 44%);
      transform: translate3d(5px, 0, 0);
    }
  
    13% {
      clip-path: polygon(0 54%, 100% 54%, 100% 44%, 0 44%);
      transform: translateZ(0);
    }
  
    13.1% {
      clip-path: polygon(0 0, 0 0, 0 0, 0 0);
      transform: translate3d(5px, 0, 0);
    }
  
    15% {
      clip-path: polygon(0 60%, 100% 60%, 100% 40%, 0 40%);
      transform: translate3d(5px, 0, 0);
    }
  
    20% {
      clip-path: polygon(0 60%, 100% 60%, 100% 40%, 0 40%);
      transform: translate3d(-5px, 0, 0);
    }
  
    20.1% {
      clip-path: polygon(0 0, 0 0, 0 0, 0 0);
      transform: translate3d(5px, 0, 0);
    }
  
    25% {
      clip-path: polygon(0 85%, 100% 85%, 100% 40%, 0 40%);
      transform: translate3d(5px, 0, 0);
    }
  
    30% {
      clip-path: polygon(0 85%, 100% 85%, 100% 40%, 0 40%);
      transform: translate3d(-5px, 0, 0);
    }
  
    30.1% {
      clip-path: polygon(0 0, 0 0, 0 0, 0 0);
    }
  
    35% {
      clip-path: polygon(0 63%, 100% 63%, 100% 80%, 0 80%);
      transform: translate(-5px);
    }
  
    40% {
      clip-path: polygon(0 63%, 100% 63%, 100% 80%, 0 80%);
      transform: translate(5px);
    }
  
    45% {
      clip-path: polygon(0 63%, 100% 63%, 100% 80%, 0 80%);
      transform: translate(-5px);
    }
  
    50% {
      clip-path: polygon(0 63%, 100% 63%, 100% 80%, 0 80%);
      transform: translate(0);
    }
  
    55% {
      clip-path: polygon(0 10%, 100% 10%, 100% 0, 0 0);
      transform: translate3d(5px, 0, 0);
    }
  
    60% {
      clip-path: polygon(0 10%, 100% 10%, 100% 0, 0 0);
      transform: translateZ(0);
      opacity: 1;
    }
  
    60.1% {
      clip-path: polygon(0 0, 0 0, 0 0, 0 0);
      opacity: 1;
    }
  
    to {
      clip-path: polygon(0 0, 0 0, 0 0, 0 0);
      opacity: 1;
    }
  }


`
